<template>
    <div>
        <div class="row">
            <div class="ec-t-review-wrapper">
                <div class="ec-t-review-item" v-for="review in reviews?.data" :key="item.id">
                    <div class="ec-t-review-avtar">
                        <img src="/images/review-image/man.png" alt="">
                    </div>
                    <div class="ec-t-review-content">

                        <div class="ec-t-review-top">
                            <div class="ec-t-review-name">{{ review?.user?.name }}</div>
                            <div class="ec-t-review-rating gap gap-1 d-flex">

                                <i v-for="(star, index) in ( review?.rating ?? 0)" :key="index"
                                   class="ecicon eci-star fill"></i>

                                <i v-for="(star, index) in 5 - ( review?.rating ?? 0)" :key="index"
                                   class="ecicon eci-star-o"></i>


                            </div>
                        </div>

                        <div class="ec-t-review-bottom">
                            <p>
                                {{ review?.comment }}
                            </p>
                        </div>
                    </div>
                </div>

                <Bootstrap5Pagination
                    class="mb-0"
                    :data="reviews"
                    :limit="2"
                    :show-disabled="false"
                    :size="'default'"
                    :align="'center'"
                    @pagination-change-page="getResults"
                />
            </div>


            <div class="ec-ratting-content">
                <h3>{{ $t('Add a Review') }}</h3>
                <div class="ec-ratting-form">

                    <div class="alert alert-danger" v-if="error_message !== null">
                        {{ error_message }}
                    </div>

                    <form @submit.prevent="create">
                        <div class="ec-ratting-star">
                            <span>{{ $t('Your rating') }}:</span>
                            <!--                            <div class="ec-t-review-rating">-->
                            <!--                                <i class="ecicon eci-star fill"></i>-->
                            <!--                                <i class="ecicon eci-star fill"></i>-->
                            <!--                                <i class="ecicon eci-star-o"></i>-->
                            <!--                                <i class="ecicon eci-star-o"></i>-->
                            <!--                                <i class="ecicon eci-star-o"></i>-->
                            <!--                            </div>-->


                            <div class="star-rating" :class="{ 'is-invalid' : isInvalid('comment')}">
                                <input class="radio-input" type="radio" id="star5" name="star-input" value="5"
                                       v-model="item.rating"/>
                                <label class="radio-label" for="star5" title="5 stars">5 stars</label>

                                <input class="radio-input" type="radio" id="star4" name="star-input" value="4"
                                       v-model="item.rating"/>
                                <label class="radio-label" for="star4" title="4 stars">4 stars</label>

                                <input class="radio-input" type="radio" id="star3" name="star-input" value="3"
                                       v-model="item.rating"/>
                                <label class="radio-label" for="star3" title="3 stars">3 stars</label>

                                <input class="radio-input" type="radio" id="star2" name="star-input" value="2"
                                       v-model="item.rating"/>
                                <label class="radio-label" for="star2" title="2 stars">2 stars</label>

                                <input class="radio-input" type="radio" id="star1" name="star-input" value="1"
                                       v-model="item.rating"/>
                                <label class="radio-label" for="star1" title="1 star">1 star</label>
                            </div>

                            <div class="invalid-feedback" v-if="isInvalid('rating')">
                                {{ isInvalid('rating') }}
                            </div>

                        </div>

                        <div class="ec-ratting-input form-submit">

                            <textarea v-model="item.comment" class="form-control"
                                      :class="{ 'is-invalid' : isInvalid('comment')}"
                                      :placeholder="$t('Your feedback on the evaluation')"></textarea>

                            <div class="invalid-feedback" v-if="isInvalid('comment')">
                                {{ isInvalid('comment') }}
                            </div>

                            <button class="btn btn-primary" type="submit" value="Submit">{{ $t('Send') }}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import {useToast} from "vue-toastification";
import {Bootstrap5Pagination} from 'laravel-vue-pagination'

const toast = useToast();

export default {
    props: ['product_id'],
    components: {
        Bootstrap5Pagination
    },
    data() {
        return {
            reviews: [],
            form_options: {},
            item: {},
            validationErrors: null,
            error_message: null,
        }
    },
    created() {
        this.getResults();
    },
    methods: {
        isInvalid(name) {
            return this.validationErrors != null ? this.validationErrors[name]?.join() : false;
        },
        create() {

            const id = toast.info(this.$t('creating ...'), {icon: 'fa-solid fa-cloud-arrow-up'});

            this.validationErrors = null;
            this.error_message = null;


            let formData = new FormData();
            Object.entries(this.item).forEach(([key, value]) => {
                formData.append(key, value);
            });

            console.log('--- this.product?.id');
            console.log(this.product_id);
            formData.append('product_id', this.product_id);


            const that = this;
            axios.post('reviews',
                formData
            ).then(response => {
                toast.dismiss(id);

                toast.success(response.data.message, {
                    timeout: 3000,
                }, {icon: 'fa-solid fa-circle-check'});

                this.item = {};

                this.reviews?.data?.push(response.data.data);


            }).catch(function (error) {
                toast.dismiss(id);
                if (error.response) {
                    that.validationErrors = error.response.data.errors;
                    that.error_message = error.response.data.message;
                    toast.error(error.response.data.message, {
                        timeout: 3000,
                    }, {icon: 'fa-solid fa-circle-exclamation'});
                }
            });

        },
        getResults(page = this.$route?.query?.page ?? 1) {

            const id = toast.info(this.$t('Getting content ...'), {icon: 'fa-solid fa-download'});

            console.log('--- this.product?.id');
            console.log(this.product_id);
            axios.get('reviews', {params: {'page': page, 'product_id': this.product_id}}).then(response => {
                toast.dismiss(id);
                this.reviews = response.data;
            }, response => {
                toast.dismiss(id);
            });
        },
    }
}
</script>
